import { LayoutComponents } from "@jelly/lesson";
import config from "appConfig";

const components: LayoutComponents = {
  variant: "layout",
  data: {
    type: "table",
    options: {
      cols: 9,
      rows: 4,
      colSpan: {
        "0:0": 9,
        "1:3": 2,
        "3:1": 2,
        "3:5": 2,
        "3:7": 2,
      },
      rowsSize: [4, 1, 0.4, 1],
      colsSize: [0.3, 1, 0.2, 1.3, 1, 1, 0.5, 1, 0.7],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/27/principle/hemp-house.svg`,
                },
              },
            },
          },
        ],
        [
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/27/principle/hemp-wool.png`,
                  styles: {
                    minHeight: "74px",
                    minWidth: "74px",
                    maxHeight: "130px",
                    maxWidth: "130px",
                  },
                },
              },
              styles: {
                justifyContent: "flex-start",
              },
            },
          },
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/27/principle/hempcrete.png`,
                  styles: {
                    minHeight: "74px",
                    minWidth: "161px",
                    maxHeight: "130px",
                    maxWidth: "283px",
                  },
                },
              },
              styles: {
                justifyContent: "flex-start",
                marginRight: "20%",
              },
            },
          },
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/27/principle/loose-chenevotte.png`,
                  styles: {
                    minHeight: "74px",
                    minWidth: "74px",
                    maxHeight: "130px",
                    maxWidth: "130px",
                  },
                },
              },
              styles: {
                justifyContent: "flex-start",
                paddingRight: "15%",
              },
            },
          },
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/27/principle/hemp-lime.png`,
                  styles: {
                    minHeight: "74px",
                    minWidth: "74px",
                    maxHeight: "130px",
                    maxWidth: "130px",
                  },
                },
              },
              styles: {
                justifyContent: "flex-start",
                paddingRight: "15%",
              },
            },
          },
        ],
        [
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/27/principle/hemp-1.svg`,
                  styles: {
                    minHeight: "25px",
                    minWidth: "25px",
                    maxHeight: "40px",
                    maxWidth: "40px",
                  },
                },
              },
              styles: {
                justifyContent: "flex-start",
                paddingTop: "5%",
              },
            },
          },
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/27/principle/hemp-2a.svg`,
                  styles: {
                    minHeight: "25px",
                    minWidth: "25px",
                    maxHeight: "40px",
                    maxWidth: "40px",
                  },
                },
              },
              styles: {
                justifyContent: "flex-start",
                paddingTop: "5%",
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/27/principle/hemp-2b.svg`,
                  styles: {
                    minHeight: "25px",
                    minWidth: "25px",
                    maxHeight: "40px",
                    maxWidth: "40px",
                  },
                },
              },
              styles: {
                justifyContent: "flex-start",
                paddingTop: "5%",
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/27/principle/hemp-3.svg`,
                  styles: {
                    minHeight: "25px",
                    minWidth: "25px",
                    maxHeight: "40px",
                    maxWidth: "40px",
                  },
                },
              },
              styles: {
                justifyContent: "flex-start",
                paddingTop: "5%",
              },
            },
          },
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/27/principle/hemp-4.svg`,
                  styles: {
                    minHeight: "25px",
                    minWidth: "25px",
                    maxHeight: "40px",
                    maxWidth: "40px",
                  },
                },
              },
              styles: {
                justifyContent: "flex-start",
                paddingTop: "5%",
              },
            },
          },
        ],
        [
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "<b>Hemp wool</b> having porous absorption properties",
                  scrollbars: false,
                  formatter: "html",
                  styles: {
                    fontSize: "10px",
                  },
                },
              },
              styles: {
                alignItems: "flex-start",
                padding: "0 3% 0 0",
                justifyContent: "flex-start",
              },
            },
          },
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "<b>Hemp concrete (chenevotte mixed with clay)</b> having porous absorption properties.",
                  scrollbars: false,
                  formatter: "html",
                  styles: {
                    fontSize: "10px",
                  },
                },
              },
              styles: {
                alignItems: "flex-start",
                padding: "0 3% 0 0",
                justifyContent: "flex-start",
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "<b>Hempcrete blocks</b> can also add mass to a lightweight wall",
                  scrollbars: false,
                  formatter: "html",
                  styles: {
                    fontSize: "10px",
                  },
                },
              },
              styles: {
                alignItems: "flex-start",
                padding: "0 3% 0 0",
                justifyContent: "flex-start",
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data:
                    "<b>Loose chenevotte (hemp)</b> to be blown-in or stuffed in a partition and having porous absorption properties",
                  scrollbars: false,
                  formatter: "html",
                  styles: {
                    fontSize: "10px",
                  },
                },
              },
              styles: {
                alignItems: "flex-start",
                padding: "0 3% 0 0",
                justifyContent: "flex-start",
              },
            },
          },
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "<b>Hemp-lime plaster</b> used for coat finishes and airtightness",
                  scrollbars: false,
                  formatter: "html",
                  styles: {
                    fontSize: "10px",
                  },
                },
              },
              styles: {
                alignItems: "flex-start",
                padding: "0 25% 0 0",
                justifyContent: "flex-start",
              },
            },
          },
        ],
      ],
    },
  },
};

export default components;
